import { useMutation } from "@apollo/client/react";
import { SEND_FOR_INTERPRETATION_WITHOUT_TEMPLATE } from "../../mutations/documentHandler/sendForInterpretationWithoutTemplate";
import GET_CLIENTS_WITH_UPLOAD_UNITS from "../../queries/documentHandler/getClientsWithUploadUnits";

export const useSendForInterpretationWithoutTemplate = ({
  onCompleted,
  onError,
}: {
  onCompleted: (result: any) => void;
  onError: () => void;
}) => {
  const [interpretWithoutTemplate, { data, loading, error }] = useMutation(
    SEND_FOR_INTERPRETATION_WITHOUT_TEMPLATE,
    {
      onCompleted: onCompleted,
      onError: onError,
      refetchQueries: [GET_CLIENTS_WITH_UPLOAD_UNITS],
      awaitRefetchQueries: true,
    },
  );

  return { interpretWithoutTemplate, data, loading, error };
};
